module.exports = __webpack_public_path__ + "img/chavin_1.4a8d2df1.png";